module.exports = __webpack_public_path__ + "static/bsas012.thumb-91625d58d032d078638b59f59d08bea5.jpg";